import * as React from "react"
import { Block } from "./library/container"
import { VideoCookieWrapper } from "./cookiebar"

export interface VideoBlockProps {
  readonly videoUrl: string
  readonly videoName: string
  readonly autoplay: boolean
  readonly controls: boolean
  readonly info: boolean
}

export function VideoRewriteSrc(video: VideoBlockProps) {
  let newSrc = video.videoUrl

  if (newSrc.indexOf("youtube.com") >= 0) {
    newSrc = newSrc.replace("youtube.com", "youtube-nocookie.com")
    newSrc = video.autoplay ? newSrc.replace("autoplay=0", "autoplay=1") + "&mute=1" : newSrc
    newSrc = !video.controls ? newSrc + "&controls=0" : newSrc
    newSrc = !video.info ? newSrc + "&showinfo=0" : newSrc
  }

  return newSrc;
}

export const VideoBlock: (props: VideoBlockProps) => JSX.Element | null = p => {
  const src = VideoRewriteSrc(p)

  return src != "" ? (
    <Block>
      <figure className="block block--video block--media container--mg align--center">
        <div className="block__visual block__video align--center">
          <VideoCookieWrapper
            videoUrl={src}
            videoName={p.videoName}
            showCookiebar={(visible: boolean) => { }}
          />
        </div>
      </figure>
    </Block>
  ) : null
}

{/* TH: Added to styleguide! */ }
